import { render, staticRenderFns } from "./EditarConcepto.vue?vue&type=template&id=1e6405d6&"
import script from "./EditarConcepto.vue?vue&type=script&lang=js&"
export * from "./EditarConcepto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports